import {get, post} from 'external/axios';

export class ClientService {
	async getClients() {
		return get(`/client/all`);
	}

	async getClientById(clientId) {
		return get(`/client/id/${clientId}`);
	}

	async getProfile(clientId) {
			return get(`/client/fetchProfile/${clientId}`);
	}

	async updateProfile(request) {
			return post('/client/updateProfile', request);
	}

	async updatePassword(request) {
			return post('/client/updatePassword', request);
	}

	async createClient(client) {
		return post('/client/create', client);
	}

	async updateClient(client) {
		return post('/client/update', client);
	}
}

export const clientService = new ClientService();